module.exports = __webpack_public_path__ + "img/ditu.9ae0fb1d.png";